import PageHeadline from '../../components/molecules/headlines/PageHeadline.vue'
import DecorationSubTitle from '../../components/atoms/decoration/DecorationSubTitle.vue'

export default {
  components: { PageHeadline, DecorationSubTitle }
}
